export class PostUpdate implements PostUpdateInterface {
  id = 0
  content = ''
  topicId = 0
}
